import React from 'react';
import { Container, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LearningStrategyCard from './LearningStrategyCard';

// Import images
import apprenticeImg from '../assets/images/learning-strategy/apprentice.svg';
import inductiveImg from '../assets/images/learning-strategy/inductive.svg';
import deductiveImg from '../assets/images/learning-strategy/deductive.svg';
import discoveryImg from '../assets/images/learning-strategy/discovery.svg';
import incidentalImg from '../assets/images/learning-strategy/incidental.svg';
import learningCubeImg from '../assets/images/learning-strategy/learning_cube.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '48px auto 0 auto',
    padding: '32px 0',
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 2px 16px rgba(21,28,67,0.06)',
    textAlign: 'center',
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(6),
    color: '#151c43',
    fontWeight: 700,
  },
  centerImage: {
    width: '20rem',
    height: 'auto',
    margin: 'auto',
  },
  gridContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
  },
  gridItem: {
    display: 'flex',
    justifyContent: 'center',
  }
}));

const getPositionClass = (index, length) => {
  if (index === length - 1) {
    return { lg: { gridColumn: '2 / 4', gridRow: '3', marginTop: '-2rem' } };
  }
  return index % 2 === 0
    ? { lg: { gridColumn: '1 / 2', gridRow: Math.floor(index / 2) + 1 } }
    : { lg: { gridColumn: '4 / 5', gridRow: Math.floor(index / 2) + 1 } };
};

const LearningStrategiesSection = () => {
  const classes = useStyles();

  const strategies = [
    {
      title: "Apprentice",
      subtitle: "Mentor-Student interaction",
      description:
        "Content is presented in a systematic step-by-step procedural way so a student can learn by following simple steps.",
      image: apprenticeImg
    },
    {
      title: "Incidental",
      subtitle: "Case Studies",
      description:
        "Content is presented in real-life scenarios or case studies and the 'events' in the story trigger the learning experience. These events lead to incidental learning.",
      image: incidentalImg
    },
    {
      title: "Deductive",
      subtitle: "Scenario based learning",
      description:
        "Apply the learning to real-life scenarios.",
      image: deductiveImg
    },
    {
      title: "Inductive",
      subtitle: "Example based learning",
      description:
        "Example based learning is a teaching method that uses examples to explain a concept or idea.",
      image: inductiveImg
    },
    {
      title: "Discovery",
      subtitle: "Learn through experimentation",
      description:
        "The student is given a problem and is asked to solve it using real life experiments.",
      image: discoveryImg
    },
  ];

  return (
    <Container className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        Learning Strategies
      </Typography>

      <Grid container spacing={3} className={classes.gridContainer}>
        {/* Center image */}
        <Grid item xs={12} lg={4} className={classes.gridItem}>
          <img
            src={learningCubeImg}
            alt="Learning Strategies"
            className={classes.centerImage}
          />
        </Grid>

        {/* Strategy cards */}
        {strategies.map((strategy, index) => (
          <Grid item xs={12} sm={6} lg={3} key={index} className={classes.gridItem}>
            <LearningStrategyCard
              strategy={strategy}
              style={getPositionClass(index, strategies.length)}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default LearningStrategiesSection; 